import type { FaireProductEntity } from "../../entity_types/product";

export const p_9fz2mn76h8: FaireProductEntity = {
  token: "p_9fz2mn76h8",
  type: "product",
  name: "Color Glitter Gel Pen - Assorted Color, Case",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/70c7fd03d47f65be6d9d518057e3f7b9717262e9ec030400739d9d3b9fd78338.jpeg",
  priceDollars: 0.19,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
